import React from "react";
import { OwIconButton } from "../OwIconButton/OwIconButton";
import OwInputWrapper from "../OwInputWrapper/OwInputWrapper";
import "./MobilePlusMinusInput.scss";
import UIService from "../../../services/UIService";
import ISupplierModel from "@models/ISupplierModel";

type Props = {
    readOnly: boolean;
    enableIncrement: boolean;
    enableDecrement: boolean;
    incrementQtyFn: () => void;
    decrementQtyFn: () => void;
    totalValue: number;
    name: string;
    inputFn: (e: React.ChangeEvent<any>) => void;
    supplierModel?: ISupplierModel;
    qtyToPick: number;
};

export const MobilePlusMinusInput = (props: Props) => {
    const getQtyStepValue = (): number => {
        let step = 1;

        // Get the step based on supplier's qty_precision
        if (props.supplierModel?.qty_precision !== undefined && props.supplierModel.qty_precision > 0) {
            switch (props.supplierModel.qty_precision) {
                case 1:
                    step = 0.1;
                    break;
                case 2:
                    step = 0.01;
                    break;
                case 3:
                    step = 0.001;
                    break;
                default:
                    step = 1;
                    break;
            }
        }

        return step;
    };

    return (
        <div className="MobilePlusMinusInput row mt-5">
            <div className="col-12 d-flex align-items-center justify-content-center">
                {props.readOnly ? null : (
                    <div>
                        <OwIconButton
                            iconClass={"fa-3x fas fa-plus-circle"}
                            iconColorClass={props.enableIncrement ? "" : "text-muted"}
                            fn={props.incrementQtyFn}
                        />
                    </div>
                )}
                <OwInputWrapper
                    className={"w-10r ms-2 me-2 qty-picked"}
                    name={props.name}
                    type={"number"}
                    value={props.totalValue}
                    fn={props.inputFn}
                    onWheelFn={UIService.stopScrollWheel}
                    supplierModel={props.supplierModel}
                    step={getQtyStepValue()}
                    min={0}
                    max={props.qtyToPick}
                />
                {/*<OwTitle title={`${qtyPicked}`} className={"d-inline-flex ms-5 me-5 qty-picked"} disableTranslation={true} />*/}
                {props.readOnly ? null : (
                    <div>
                        <OwIconButton
                            iconClass={"fa-3x fas fa-minus-circle"}
                            iconColorClass={props.enableDecrement ? "" : "text-muted"}
                            fn={props.decrementQtyFn}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
